var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{ref:"main",class:[_vm.$style.main, !_vm.pageIsScroll && _vm.$style.noScroll],style:(_vm.stylePadding),attrs:{"id":"main"}},[_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }